var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.value,"rules":_vm.rules,"dense":"","single-line":"","append-icon":"mdi-open-in-new"},on:{"input":(v) => _vm.$emit('input', v),"click:append":_vm.openUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }